import { render, staticRenderFns } from "./DxAiArticle.vue?vue&type=template&id=295519b8&scoped=true&"
import script from "./DxAiArticle.vue?vue&type=script&lang=js&"
export * from "./DxAiArticle.vue?vue&type=script&lang=js&"
import style0 from "./DxAiArticle.vue?vue&type=style&index=0&id=295519b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295519b8",
  null
  
)

export default component.exports